import Api from '@/ultils/api-base'

export default {
   getUserInfo(body) {
      return Api('POST', 'wsGetSubMainInfo', body)
   },
   getSubAccountInfo(body) {
      return Api('POST', 'wsGetSubAccountInfo', body)
   },
   getAccountsDetail(body) {
      return Api('POST', 'wsGetAccountsDetail', body)
   },
   getPostageInfo(body) {
      return Api('POST', 'wsGetPostageInfo', body)
   },
   getPrePostageForGraph(body) {
      return Api('POST', 'wsGetPrePostageForGraph', body)
   },
   getPosPostageForGraph(body) {
      return Api('POST', 'wsGetPosPostageForGraph', body)
   },
   getRefillReport(body) {
      return Api('POST', 'wsGetRefillReport', body)
   },
   getPostageDetailInfo(body) {
      return Api('POST', 'wsGetPostageDetailInfo', body)
   },
   getAirTimeData(body) {
      return Api('POST', 'wsGetAirtimeData', body)
   },
   confirmAirTime(body) {
      return Api('POST', 'wsDoActionService', body)
   },
   getAirTimeCredit(body) {
      return Api('POST', 'wsGetAirtimeCredit', body)
   },
   resetPasswordIshare(body) {
      return Api('POST', 'wsResetPasswordIshare', body)
   },
   changePasswordIshare(body) {
      return Api('POST', 'wsChangePasswordIshare', body)
   },
   share(body) {
      return Api('POST', 'wsIshare', body)
   },
   validateSerialCard(body) {
      return Api('POST', 'validateSerialCard', body)
   },
   topup(body) {
      return Api('POST', 'wsTopup', body)
   },
   getListDataPackages(body) {
      return Api('POST', 'wsGetListDataPackages', body)
   },
   getDataPackageDetailByCode(body) {
      return Api('POST', 'wsGetDataPackageDetailByCode', body)
   },
   doActionService(body) {
      return Api('POST', 'wsDoActionService', body)
   },
   debitAccountUmoney(body) {
      return Api('POST', 'wsDebitAccountUmoney', body)
   },
   getEwalletInfo(body) {
      return Api('POST', 'wsGetEwalletInfo', body)
   },
   getOtpWithoutPassword(body) {
      return Api('POST', 'wsGetOtpWithoutPassword', body)
   },
   getListDataPromotion(body) {
      return Api('POST', 'wsGetListDataPromotion', body)
   },
   getDataPromotionDetail(body) {
      return Api('POST', 'wsGetDataPromotionDetail', body)
   },
   wsGetDetailPackage(body) {
      return Api('POST', 'wsGetDetailPackage', body)
   },
   findStoreByAddr(body) {
      return Api('POST', 'wsFindStoreByAddr', body)
   },
   getProvinces(body) {
      return Api('POST', 'wsGetProvinces', body)
   },
   getDistricts(body) {
      return Api('POST', 'wsGetDistricts', body)
   },
   getRangeYourself(body) {
      return Api('POST', 'wsGetRangeYourself', body)
   },
   doYourSelf(body) {
      return Api('POST', 'wsDoYourSelf', body)
   },
   getNearestStores(body) {
      return Api('POST', 'wsGetNearestStores', body)
   },
   getListDataAddOn(body) {
      return Api('POST', 'wsGetAllDataAddon', body)
   },
   getLstProductForTransfer(body) {
      return Api('POST', 'wsGetLstProductForTransfer', body, false)
   },
   getCustInfoTransfer(body) {
      return Api('POST', 'wsGetCustInfoTransfer', body)
   },

   //anhnt
   CreateOrderPost2Pre(body) {
      return Api('POST', 'wsCreateOrderPost2Pre', body, false)
   },
   // end anhnt
   getContractFileTransfer(body) {
      return Api('POST', 'wsGetContractFileTransfer', body, false)
   },
   getFeeTransfer(body) {
      return Api('POST', 'wsGetFeeTransfer', body, false)
   },
   createTransferOrderPrePos(body) {
      return Api('POST', 'wsCreateTransferOrderPrePos', body, false)
   },
   trackingOrder(body) {
      return Api('POST', 'wsTrackingOrder', body, false)
   },
   GetNoticeWebview(body) {
      return Api('POST', 'wsGetNoticeWebview', body)
   },
   GetCurrentUsedSubServices(body) {
      return Api('POST', 'wsGetCurrentUsedSubServices', body)
   },
   GetServiceBestSeller(body) {
      return Api('POST', 'wsGetServiceBestSeller', body)
   },
   GetBannerWebview(body) {
      return Api('POST', 'wsGetBannerWebview', body)
   },
   GetBannerPtg(body) {
      return Api('POST', 'ptg_getBanner', body)
   },
   GetNoteRoaming(body) {
      return Api('POST', 'ptg_getListAppParams', body)
   },
   wsGetListPacketDataAll(body) {
      return Api('POST', 'wsGetListPacketDataAll', body)
   },
   getUMoney(body) {
      return Api('POST', 'wsGetUMoney', body)
   },
   getPrecinct(body) {
      return Api('POST', 'wsGetPrecincts', body)
   },
   getListReceipt(body) {
      return Api('POST', 'wsGetListReceiptV2', body)
   },
   getListInvoice(body) {
      return Api('POST', 'wsGetListInvoiceV2', body)
   },
   getListInvoiceStatement(body) {
      return Api('POST', 'wsGetListInvoiceStatementV2', body)
   },
   getViewInvoiceInfo(body) {
      return Api('POST', 'wsViewInvoiceInfoV2', body)
   },
   getViewReceiptInfo(body) {
      return Api('POST', 'wsViewReceiptInfoV2', body)
   },
   getViewInvoiceStatement(body) {
      return Api('POST', 'wsViewInvoiceStatementV2', body)
   },
   getListInvoicePrepaid(body) {
      return Api('POST', 'wsGetListInvoicePrepaidV2', body)
   },
   forgotPass(body) {
      return Api('POST', 'forgotPass', body)
   },
   viewInvoicePrepaidInfo(body) {
      return Api('POST', 'wsViewInvoicePrepaidInfoV2', body)
   },
   getInfoChangeSim(body) {
      return Api('POST', 'wsGetInfoChangeSim', body, true, true)
   },
   changeSim(body) {
      return Api('POST', 'wsChangeSim', body, true, true)
   },
   checkSerial(body) {
      return Api('POST', 'wsCheckSerial', body, true, true)
   },
   getInfoChangeScratch(body) {
      return Api('POST', 'wsGetInfoChangeScratch', body, true, true)
   },
   bccsGetOTP(body) {
      return Api('POST', 'wsBccsGetOTP', body, true)
   },
   bccsGetOTPScratchCard(body) {
      return Api('POST', 'wsBccsGetOTPScratchCard', body, true)
   },
   changeScratch(body) {
      return Api('POST', 'wsChangeScratch', body, true)
   },
   getListChangeScratchCard(body) {
      return Api('POST', 'wsGetListChangeScratchCard', body, true)
   },
   getChangeScratchCardDetail(body) {
      return Api('POST', 'wsGetChangeScratchCardDetail', body, true)
   },
   xboxRegisterService(body) {
      return Api('POST', 'wsXboxRegisterService', body)
   },
   xboxGetGift(body) {
      return Api('POST', 'wsXboxGetGift', body)
   },
   xboxGetService(body) {
      return Api('POST', 'wsXboxGetService', body)
   },
   getVasServices(body) {
      return Api('POST', 'wsGetServicesByGroupCode', body)
   },
   getServiceDetailByCode(body) {
      return Api('POST', 'wsGetServiceDetailByServiceCode', body)
   },
   getListContact(body) {
      return Api('POST', 'wsGetListContact', body)
   },
   registerRoaming(body) {
      return Api('POST', 'wsRegisterRoaming', body)
   },
   cancelRoaming(body) {
      return Api('POST', 'wsCancelRoaming', body)
   },
   getRoaming(body) {
      return Api('POST', 'wsViewVas', body)
   },
   getProblems(body) {
      return Api('POST', 'wsGetProblems', body)
   },
   getProblemsByIsdn(body) {
      return Api('POST', 'wsGetProblemsByIsdn', body)
   },
   getStarsTextSuggest(body) {
      return Api('POST', 'wsGetStarsTextSuggest', body)
   },
   getStarsTextSuggestOfSurvey(body) {
      return Api('POST', 'WS_getConfigSurveyFE', body)
   },
   setStarsTextSuggestOfSurvey(body) {
      return Api('POST', 'WS_surveyFe', body)
   },
   evaluateNVKT(body) {
      return Api('POST', 'wsEvaluateNVKT', body)
   },
   getServiceType(body) {
      return Api('POST', 'wsGetServiceType', body)
   },
   getGroupCategory(body) {
      return Api('POST', 'wsGetGroupCategory', body)
   },
   getProblemType(body) {
      return Api('POST', 'wsGetProblemType', body)
   },
   createProblem(body) {
      return Api('POST', 'wsCreateProblem', body)
   },
   getCommonProblem(body) {
      return Api('POST', 'wsGetCommonProblem', body)
   },
   checkRoaming(body) {
      return Api('POST', 'wsCheckStatusRoaming', body)
   },
   registerRoamingWithOtp(body) {
      return Api('POST', 'wsRegisterRoamingWithOtp', body)
   },
   verifyRoamingWithOtp(body) {
      return Api('POST', 'wsVerifyOtpRoaming', body)
   },
   wsGetAppParam(body) {
      return Api('POST', 'wsGetAppParam', body)
   },
   getAllPacketRoaming(body) {
      return Api('POST', 'wsGetAllPacket', body)
   },
   getAllPacketRoamingNew(body) {
      return Api('POST', 'ptg_getListDigitalService', body)
   },
   getInfoPacket(body) {
      return Api('POST', 'wsGetInfoPacket', body)
   },
   registerPacketRoaming(body) {
      return Api('POST', 'wsRegisterPacketRoaming', body)
   },
   checkQrCode(body) {
      return Api('POST', 'wsCheckQrCode', body)
   },
   loginQrCode(body) {
      return Api('POST', 'wsStaffLogin', body)
   },
   checkValidFTTH(body) {
      return Api('POST', 'wsIsValidFTTH', body)
   },
   configQrCode(body) {
      return Api('POST', 'wsConfigQrCode', body)
   },
   saveConfigQR(body) {
      return Api('POST', 'wsConfigQR', body)
   },
   reportHistory(body) {
      return Api('POST', 'wsReportHistory', body)
   },
   createProblemQrCode(body) {
      return Api('POST', 'wsCreateProblemQrCode', body)
   },
   getProblemsByIsdnQrCode(body) {
      return Api('POST', 'wsGetProblemsByIsdnQrCode', body)
   },
   buyRoamingLater(body) {
      return Api('POST', 'wsBuyRoamingLater', body)
   },
   ptg_getAllQuestionSupport(body) {
      return Api('POST', 'ptg_getAllQuestionSupport', body)
   },
   ptg_getListAppParams(body){
       return Api('POST', 'ptg_getListAppParams', body)
   }
}
